import { Link } from "react-router-dom";
import { RightArrowIcon } from "./RightArrow";
const InstructorArea = ({ data }: any) => {
  return (
    <div className="col-xl-6">
      <div className="instructor__item-two tg-svg">
        <div className="instructor__thumb-two">
          <img
            src={
              data?.image?.node?.sourceUrl ||
              "../../assets/img/index/trainer.png"
            }
            width={189}
            height={223}
            alt="img-text"
          />
          <div className="shape-one">
            <img
              src={
                data?.shapeUrl ||
                "../../assets/img/instructor/instructor_shape01.svg"
              }
              alt="img-text"
              className="injectable"
              width={224}
              height={158}
            />
          </div>
          <div className="shape-two">
            <span
              className="svg-icon"
              id="instructor-svg"
              data-svg-icon={
                data?.svgUrl ||
                "../../assets/img/instructor/instructor_shape02.svg"
              }
            ></span>
          </div>
        </div>
        <div className="instructor__content-two">
          <h3 className="title">
            <a href="https://mescjobs.in/" target="_blank" rel="noreferrer">
              {data?.title || "Register as an Employer"}
            </a>
          </h3>
          <p>
            {data?.content ||
              "Apply as an employer and bridge the gap to empower the future"}
          </p>
          <div className="tg-button-wrap">
            <Link to={data?.link} className="btn arrow-btn">
              {data?.buttonText || "Apply Now"}
              {/* <img
                src={data?.buttonSvg || "/assets/img/icons/right_arrow.svg"}
                alt="img-text"
                className="injectable"
                width={16}
                height={14}
              /> */}
              <RightArrowIcon />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InstructorArea;
